F<div *ngIf="userPen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md">
    <div class="bg-[#111827] w-[80vw] h-[90vh] rounded-xl shadow-2xl border border-gray-700 flex flex-col">

        <!-- Modal Header -->
        <div class="p-6 border-b border-gray-600">
            <h2 class="text-white text-xl font-semibold text-center">Security Reports for {{userPen?.domain??''}}</h2>
        </div>

        <!-- Scrollable Content -->
        <div class="flex-1 overflow-y-auto p-6 space-y-4">
            <!-- Network Scanning -->
            <div *ngIf="userPen?.report?.networkScanning" class="bg-gray-800 p-4 rounded-lg shadow-md">
                <h3 class="text-white font-semibold mb-4 flex items-center">
                    <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                    Network Scanning
                </h3>
                
                <div class="bg-gray-700 rounded-lg p-4 mb-4">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <!-- Status -->
                        <div *ngIf="userPen?.report?.networkScanning?.status" class="flex items-start">
                            <div class="p-2 rounded-full" 
                                [ngClass]="userPen?.report?.networkScanning?.status == 'pass' ? 'bg-green-900' : 'bg-red-900'">
                                <svg *ngIf="userPen?.report?.networkScanning?.status == 'pass'" class="h-6 w-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                </svg>
                                <svg *ngIf="userPen?.report?.networkScanning?.status != 'pass'" class="h-6 w-6 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                            <div class="ml-4">
                                <p class="text-sm font-bold text-gray-300">Status</p>
                                <p class="text-lg font-semibold" 
                                    [ngClass]="userPen?.report?.networkScanning?.status == 'pass' ? 'text-green-400' : 'text-red-400'">
                                    {{ userPen?.report?.networkScanning?.status | titlecase }}
                                </p>
                            </div>
                        </div>
                        
                        <!-- Open Ports -->
                        <div *ngIf="userPen?.report?.networkScanning?.data?.openPorts?.length" class="flex items-start">
                            <div class="p-2 rounded-full bg-blue-900">
                                <svg class="h-6 w-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <div class="ml-4">
                                <p class="text-sm font-bold text-gray-300">Open Ports</p>
                                <p class="text-lg font-semibold text-blue-400">
                                    {{ userPen?.report?.networkScanning?.data?.openPorts.join(', ') }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Reason and Recommendation -->
                <div *ngIf="userPen?.report?.networkScanning?.reason || userPen?.report?.networkScanning?.recommendation" class="bg-gray-700 rounded-lg p-4">
                    <div *ngIf="userPen?.report?.networkScanning?.reason" class="mb-4">
                        <h4 class="text-white font-semibold mb-2 flex items-center">
                            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Reason
                        </h4>
                        <p class="text-gray-400 pl-6">{{ userPen?.report?.networkScanning?.reason }}</p>
                    </div>
                    
                    <div *ngIf="userPen?.report?.networkScanning?.recommendation">
                        <h4 class="text-white font-semibold mb-2 flex items-center">
                            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                            </svg>
                            Recommendation
                        </h4>
                        <p class="text-gray-400 pl-6">{{ userPen?.report?.networkScanning?.recommendation }}</p>
                    </div>
                </div>
            </div>

            <!-- Cipher Suite -->
            <div *ngIf="userPen?.report?.cipherSuite" class="bg-gray-800 p-4 rounded-lg shadow-md">
                <h3 class="text-white font-semibold mb-4 flex items-center">
                    <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                    Cipher Suite
                </h3>
                
                <div class="bg-gray-700 rounded-lg p-4 mb-4">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <!-- Status -->
                        <div *ngIf="userPen?.report?.cipherSuite?.status" class="flex items-start">
                            <div class="p-2 rounded-full" 
                                [ngClass]="userPen?.report?.cipherSuite?.status == 'pass' ? 'bg-green-900' : 'bg-red-900'">
                                <svg *ngIf="userPen?.report?.cipherSuite?.status == 'pass'" class="h-6 w-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                </svg>
                                <svg *ngIf="userPen?.report?.cipherSuite?.status != 'pass'" class="h-6 w-6 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                            <div class="ml-4">
                                <p class="text-sm font-bold text-gray-300">Status</p>
                                <p class="text-lg font-semibold" 
                                    [ngClass]="userPen?.report?.cipherSuite?.status == 'pass' ? 'text-green-400' : 'text-red-400'">
                                    {{ userPen?.report?.cipherSuite?.status | titlecase }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Supported Protocols -->
                <div *ngIf="userPen?.report?.cipherSuite?.data?.supportedProtocols?.length" class="bg-gray-700 rounded-lg p-4 mb-4">
                    <h4 class="text-white font-semibold mb-3 flex items-center">
                        <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        Supported Protocols
                    </h4>
                    <div class="space-y-2 pl-6">
                        <div *ngFor="let protocol of userPen?.report?.cipherSuite?.data?.supportedProtocols" 
                            class="bg-gray-800 p-2 rounded">
                            <p class="text-sm text-gray-300">
                                <span class="font-medium">{{ protocol.protocol }}</span> - 
                                <span class="text-blue-400">{{ protocol.cipherSuite }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                
                <!-- Reason and Recommendation -->
                <div *ngIf="userPen?.report?.cipherSuite?.reason || userPen?.report?.cipherSuite?.recommendation" class="bg-gray-700 rounded-lg p-4">
                    <div *ngIf="userPen?.report?.cipherSuite?.reason" class="mb-4">
                        <h4 class="text-white font-semibold mb-2 flex items-center">
                            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Reason
                        </h4>
                        <p class="text-gray-400 pl-6">{{ userPen?.report?.cipherSuite?.reason }}</p>
                    </div>
                    
                    <div *ngIf="userPen?.report?.cipherSuite?.recommendation">
                        <h4 class="text-white font-semibold mb-2 flex items-center">
                            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                            </svg>
                            Recommendation
                        </h4>
                        <p class="text-gray-400 pl-6">{{ userPen?.report?.cipherSuite?.recommendation }}</p>
                    </div>
                </div>
            </div>

            <!-- DNS Enumeration -->
            <div *ngIf="userPen?.report?.dnsEnumeration" class="bg-gray-800 p-4 rounded-lg shadow-md">
                <h3 class="text-white font-semibold mb-4 flex items-center">
                    <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                    </svg>
                    DNS Enumeration
                </h3>
                
                <div class="bg-gray-700 rounded-lg p-4 mb-4">
                    <div class="flex items-start">
                        <div class="p-2 rounded-full" 
                            [ngClass]="userPen?.report?.dnsEnumeration?.status == 'pass' ? 'bg-green-900' : 'bg-red-900'">
                            <svg *ngIf="userPen?.report?.dnsEnumeration?.status == 'pass'" class="h-6 w-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                            </svg>
                            <svg *ngIf="userPen?.report?.dnsEnumeration?.status != 'pass'" class="h-6 w-6 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <div class="ml-4">
                            <p class="text-sm font-bold text-gray-300">Status</p>
                            <p class="text-lg font-semibold" 
                                [ngClass]="userPen?.report?.dnsEnumeration?.status == 'pass' ? 'text-green-400' : 'text-red-400'">
                                {{ userPen?.report?.dnsEnumeration?.status | titlecase }}
                            </p>
                        </div>
                    </div>
                </div>
                
                <!-- Reason and Recommendation -->
                <div *ngIf="userPen?.report?.dnsEnumeration?.reason || userPen?.report?.dnsEnumeration?.recommendation" class="bg-gray-700 rounded-lg p-4">
                    <div *ngIf="userPen?.report?.dnsEnumeration?.reason" class="mb-4">
                        <h4 class="text-white font-semibold mb-2 flex items-center">
                            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Reason
                        </h4>
                        <p class="text-gray-400 pl-6">{{ userPen?.report?.dnsEnumeration?.reason }}</p>
                    </div>
                    
                    <div *ngIf="userPen?.report?.dnsEnumeration?.recommendation">
                        <h4 class="text-white font-semibold mb-2 flex items-center">
                            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                            </svg>
                            Recommendation
                        </h4>
                        <p class="text-gray-400 pl-6">{{ userPen?.report?.dnsEnumeration?.recommendation }}</p>
                    </div>
                </div>
            </div>

            <!-- Test SSL -->
            <div *ngIf="userPen?.report?.testSSL" class="bg-gray-800 p-4 rounded-lg shadow-md">
                <h3 class="text-white font-semibold mb-2">SSL Security Test</h3>
                <p *ngIf="userPen?.report?.testSSL?.status" class="text-gray-300 mb-4">Status:
                    <span [ngClass]="userPen?.report?.testSSL?.status == 'pass' ? 'text-green-400' : 'text-red-400'">
                        {{ userPen?.report?.testSSL?.status | titlecase }}
                    </span>
                </p>
                <p *ngIf="userPen?.report?.testSSL?.reason" class="text-gray-300 mb-4">Reason:
                    <span class="text-gray-400">{{ userPen?.report?.testSSL?.reason }}</span>
                </p>
                <p *ngIf="userPen?.report?.testSSL?.recommendation" class="text-gray-300 mt-4">Recommendation:
                    <span class="text-gray-400">{{ userPen?.report?.testSSL?.recommendation }}</span>
                </p>

                <!-- Warnings Section -->
                <div *ngIf="getItemsBySeverity('WARN').length > 0" class="mt-6">
                    <h4 class="text-red-400 font-semibold mb-3 flex items-center">
                        <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        Warnings
                        <span class="text-gray-400 text-sm ml-2">({{ getItemsBySeverity('WARN').length }})</span>
                    </h4>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div *ngFor="let item of getItemsBySeverity('WARN')"
                            class="bg-gray-700 rounded-lg p-4 shadow-md transition-all duration-200 hover:shadow-lg border-l-4 border-red-500">
                            <div class="flex items-start">
                                <div class="p-2 rounded-full bg-red-900">
                                    <svg class="h-6 w-6 text-red-400" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </div>
                                <div class="ml-4 flex-1 overflow-hidden">
                                    <div class="flex justify-between">
                                        <p class="text-sm font-bold text-gray-300 truncate max-w-[70%]">{{
                                            getHumanFriendlyName(item.id) }}</p>
                                        <span class="text-sm font-medium text-red-400">
                                            {{ item.severity }}
                                        </span>
                                    </div>
                                    <p
                                        class="mt-2 text-sm text-gray-300 break-all whitespace-normal overflow-hidden word-break-break-word">
                                        {{ item.finding }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Other Issues Section -->
                <div *ngIf="getItemsBySeverity('OTHER').length > 0" class="mt-6">
                    <h4 class="text-yellow-400 font-semibold mb-3 flex items-center">
                        <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        Minor Concerns
                        <span class="text-gray-400 text-sm ml-2">({{ getItemsBySeverity('OTHER').length }})</span>
                    </h4>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div *ngFor="let item of getItemsBySeverity('OTHER')"
                            class="bg-gray-700 rounded-lg p-4 shadow-md transition-all duration-200 hover:shadow-lg border-l-4 border-yellow-500">
                            <div class="flex items-start">
                                <div class="p-2 rounded-full bg-yellow-900">
                                    <svg class="h-6 w-6 text-yellow-400" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div class="ml-4 flex-1 overflow-hidden">
                                    <div class="flex justify-between">
                                        <p class="text-sm font-bold text-gray-300 truncate max-w-[70%]">{{
                                            getHumanFriendlyName(item.id)
                                            }}</p>
                                        <span class="text-sm font-medium text-yellow-400">
                                            {{ item.severity }}
                                        </span>
                                    </div>
                                    <p
                                        class="mt-2 text-sm text-gray-300 break-all whitespace-normal overflow-hidden word-break-break-word">
                                        {{ item.finding }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Passed Tests Section (OK) -->
                <div *ngIf="getItemsBySeverity('OK').length > 0" class="mt-6">
                    <h4 class="text-green-400 font-semibold mb-3 flex items-center">
                        <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        Passed Tests
                        <span class="text-gray-400 text-sm ml-2">({{ getItemsBySeverity('OK').length }})</span>
                    </h4>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div *ngFor="let item of getLimitedItems('OK')"
                            class="bg-gray-700 rounded-lg p-4 shadow-md transition-all duration-200 hover:shadow-lg border-l-4 border-green-500">
                            <div class="flex items-start">
                                <div class="p-2 rounded-full bg-green-900">
                                    <svg class="h-6 w-6 text-green-400" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <div class="ml-4 flex-1 overflow-hidden">
                                    <div class="flex justify-between">
                                        <p class="text-sm font-bold text-gray-300 truncate max-w-[70%]">{{
                                            getHumanFriendlyName(item.id)
                                            }}</p>
                                        <span class="text-sm font-medium text-green-400">
                                            {{ item.severity }}
                                        </span>
                                    </div>
                                    <p
                                        class="mt-2 text-sm text-gray-300 break-all whitespace-normal overflow-hidden word-break-break-word">
                                        {{ item.finding }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Show More/Less Button for Passed Tests -->
                    <div *ngIf="getItemsBySeverity('OK').length > initialDisplayLimit" class="mt-3 flex justify-center">
                        <button 
                            (click)="toggleShowAllPassed()" 
                            class="text-sm text-gray-400 hover:text-gray-300 flex items-center transition-colors duration-200">
                            <span *ngIf="!showAllPassed">
                                Show All {{ getItemsBySeverity('OK').length }} Items
                                <svg class="h-4 w-4 ml-1 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                            <span *ngIf="showAllPassed">
                                Collapse
                                <svg class="h-4 w-4 ml-1 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
                <!-- Info Section -->
                <div *ngIf="getItemsBySeverity('INFO').length > 0" class="mt-6">
                    <h4 class="text-blue-400 font-semibold mb-3 flex items-center">
                        <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Information
                        <span class="text-gray-400 text-sm ml-2">({{ getItemsBySeverity('INFO').length }})</span>
                    </h4>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div *ngFor="let item of getLimitedItems('INFO')"
                            class="bg-gray-700 rounded-lg p-4 shadow-md transition-all duration-200 hover:shadow-lg border-l-4 border-blue-500">
                            <div class="flex items-start">
                                <div class="p-2 rounded-full bg-blue-900">
                                    <svg class="h-6 w-6 text-blue-400" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div class="ml-4 flex-1 overflow-hidden">
                                    <div class="flex justify-between">
                                        <p class="text-sm font-bold text-gray-300 truncate max-w-[70%]">{{
                                            getHumanFriendlyName(item.id) }}</p>
                                        <span class="text-sm font-medium text-blue-400">
                                            {{ item.severity }}
                                        </span>
                                    </div>
                                    <p
                                        class="mt-2 text-sm text-gray-300 break-all whitespace-normal overflow-hidden word-break-break-word">
                                        {{ item.finding }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Show More/Less Button for Info -->
                    <div *ngIf="getItemsBySeverity('INFO').length > initialDisplayLimit" class="mt-3 flex justify-center">
                        <button 
                            (click)="toggleShowAllInfo()" 
                            class="text-sm text-gray-400 hover:text-gray-300 flex items-center transition-colors duration-200">
                            <span *ngIf="!showAllInfo">
                                Show All {{ getItemsBySeverity('INFO').length }} Items
                                <svg class="h-4 w-4 ml-1 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                            <span *ngIf="showAllInfo">
                                Collapse
                                <svg class="h-4 w-4 ml-1 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>

              
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="p-6 border-t border-gray-600 flex justify-center">
            <button type="button"
                class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition duration-200 ease-in-out"
                (click)="closeReportClick()">
                Close
            </button>
        </div>
    </div>
</div>
